import { render, staticRenderFns } from "./PagesSection.vue?vue&type=template&id=c99cc1e6&scoped=true&"
import script from "./PagesSection.vue?vue&type=script&lang=ts&"
export * from "./PagesSection.vue?vue&type=script&lang=ts&"
import style0 from "./PagesSection.vue?vue&type=style&index=0&id=c99cc1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99cc1e6",
  null
  
)

export default component.exports